<template>
<div class="page-container">
  <el-button
    @click="back"
    type="text">
    返回
  </el-button>
  <span>{{ruleObj.ruleName}}</span>
  <el-form
    :inline="true"
    :model="form"
    class="demo-form-inline">
    <el-form-item
      label="操作状态:">
      <el-select
        v-model="form.executionStatus"
        placeholder="请选择操作状态">
        <el-option
          label="全部状态"
          value=""></el-option>
        <el-option
          label="成功"
          value="0"></el-option>
        <el-option
          label="失败"
          value="1">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item
      label="请选择操作时间:">
      <el-select
        @change="timeSelectChange"
        v-model="form.timeType"
        placeholder="请选择时间">
        <el-option
          label="最近15分钟"
          value="1">
        </el-option>
        <el-option
          label="最近1小时"
          value="2">
        </el-option>
        <el-option
          label="最近4小时"
          value="3">
        </el-option>
        <el-option
          label="自定义"
          value="4">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item v-if="form.timeType==='4'">
      <el-date-picker
        @change="timeChange"
        v-model="form.time"
        value-format="yyyy-MM-dd HH:mm:ss"
        type="datetimerange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期">
      </el-date-picker>
    </el-form-item>
    <el-form-item>
      <el-button
        type="primary"
        @click="getloglist">
        查询
      </el-button>
    </el-form-item>
  </el-form>
  <el-table
    :data="tableData"
    stripe
    style="width: 100%">
    <el-table-column
      prop="executionTime"
      label="执行时间"
      width="">
    </el-table-column>
    <el-table-column
      prop="name"
      label="执行状态"
      :formatter="handleState"
      width="">
    </el-table-column>
    <el-table-column
      prop="address"
      label="操作">
      <template slot-scope="scope">
        <el-button
          type="text"
          size="mini"
          @click="showDetaile(scope.row)">详情</el-button>
      </template>
    </el-table-column>
  </el-table>
  <el-dialog
     :close-on-click-modal="false"
    title="日志详情"
    :append-to-body="true"
    center
    :visible.sync="dialogTableVisible">
    <el-table :data="gridData">
      <el-table-column
        property="device"
        label="执行设备"
        width="150">
      </el-table-column>
      <el-table-column
        property="status"
        label="执行状态"
        width="200">
      </el-table-column>
      <el-table-column
        property="reason"
        label="失败原因">
      </el-table-column>
    </el-table>
  </el-dialog>
</div>
</template>

<script>
import { dateFormat } from '@/assets/js/tools.js'
import { logList, logDetaile } from '@/api/ruleEngine.js'
export default {
  name: 'operationLog',
  data () {
    return {
      dialogTableVisible: false,
      pageNumber: 1,
      pageSize: 10,
      searchCondition: '规则',
      startTime: '',
      endTime: '',
      ruleId: 1,
      ruleObj: {},
      form: {
        executionStatus: '',
        timeType: '',
        time: ''
      },
      tableData: [],
      gridData: [{
        device: '空调',
        status: '失败',
        reason: '网络连接异常'
      }]
    }
  },
  mounted () {
    console.log('params---', this.$route.params)
    this.ruleObj = this.$route.params
    this.getloglist()
  },
  methods: {
    timeSelectChange (value) {
      console.log('timeSelectChange----', value)
      let endTime = Date.now()
      let startTime = ''
      if (value === '1') {
        startTime = endTime - 15 * 60 * 1000
      } else if (value === '2') {
        startTime = endTime - 60 * 60 * 1000
      } else if (value === '3') {
        startTime = endTime - 4 * 60 * 60 * 1000
      } else {
        endTime = ''
      }
      this.form.endTime = dateFormat(endTime)
      this.form.startTime = dateFormat(startTime)
      console.log('this.form---', this.form)
    },
    getloglist () {
      const params = {
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        executionStatus: this.form.executionStatus,
        startTime: this.form.startTime,
        endTime: this.form.endTime,
        ruleId: this.ruleObj.ruleId
      }
      logList(params).then(res => {
        this.tableData = res.data.logList || this.tableData
      })
    },
    timeChange (value) {
      if (value && value.length > 1) {
        this.form.endTime = value[1]
        this.form.startTime = value[0]
      }
    },
    onSubmit () {
      console.log('submit!')
    },
    back () {
      this.$router.back()
    },
    showDetaile (row) {
      this.dialogTableVisible = true
      logDetaile({ executionId: row.executionId }).then(res => {

      })
    },
    handleState (state) {
      if (state === 0) {
        return '成功'
      } else if (state === 1) {
        return '失败'
      } else {
        return '未执行'
      }
    }
  }
}
</script>

<style lang="less" scoped>
.page-container{
  padding: 0 15px;
  .el-button{
    margin-right: 20px;
  }
}
</style>
